import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-height-2",
  "use": "icon-line-height-2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-line-height-2\"><path stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"square\" d=\"M4 15.5h12M4 5.5h12\" /><path d=\"M3 9h14v4H3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol